module.exports = __webpack_public_path__ + "img/belt.d375ea5b.png";